//This file is automatically rebuilt by the Cesium build process.
export default "struct czm_pbrParameters\n\
{\n\
vec3 diffuseColor;\n\
float roughness;\n\
vec3 f0;\n\
};\n\
";
